import { useQuery } from '@apollo/client';
import { GET_LEARNER_DOCUMENTS } from '../queries/learnerDocuments';

export const useFetchLearnerDocuments = () => {
  const { data, loading, error, refetch } = useQuery(GET_LEARNER_DOCUMENTS);

  return {
    documents: data?.documentLibrary || [],
    totalCount: data?.documentLibrary?.length || 0,
    loading,
    error,
    refetch,
  };
};
